module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_ERSCHOEPFUNG_hauptseite-hintergrund.c8ae92e4.jpg";